module.exports = __webpack_public_path__ + "img/111@2x.9554369b.png";